import { Timelapse as TimelapseType } from "@/lib/types/timelapse";
import { TimelapseStatus } from "./TimelapseStatus";
import { IoMdQrScanner } from "react-icons/io";
import { formatDistanceToNow } from "date-fns";
import { useNavigate } from "@tanstack/react-router";
import { LoadableImage } from "../atoms/LoadableImage";
import { CardGray } from "../atoms/CardGray";

type Props = {
  timelapse: TimelapseType;
  disabled: boolean
}

export const Timelapse = ({ timelapse, disabled }: Props) => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (disabled) return

    navigate({ to: "/timelapses/$id", params: { id: timelapse.id.toString() } })
  }

  return (
    <CardGray onClick={handleClick} className={`flex flex-col gap-4 p-0 rounded-b-none overflow-hidden ${!disabled ? "tansition-transform duration-300 hover:scale-102 hover:cursor-pointer" : ""}`}>
      <div className="aspect-square w-full ">
        {timelapse.coverId ? (
          <LoadableImage src={`/api/scan/${timelapse.coverId}`} />
        ) : (
          <div className="flex items-center justify-center w-full h-full text-center">
            <p>No cover</p>
          </div>
        )}
      </div>
      <div className="flex flex-col p-6 gap-6">
        <div className="flex items-center justify-between">
          <span className="font-bold">{timelapse.name}</span>
          <TimelapseStatus status={timelapse.status} />
        </div>
        <div className="flex flex-col gap-1 text-muted text-sm">
          <div className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-2">
              <IoMdQrScanner />
              <span>{timelapse.scanner.name}</span>
            </div>
            <span>{`# ${timelapse.scans}`}</span>
          </div>
          {timelapse.lastScan && (
            <span>{`Last scan: ${formatDistanceToNow(timelapse.lastScan)} ago`}</span>
          )}
        </div>
      </div>
    </CardGray>
  )
}
